//userAgent
var ua = navigator.userAgent;

//userAgent デバイス判定
var _ua = (function(u){
  return {
    isTablet:(u.indexOf("windows") != -1 && u.indexOf("touch") != -1 && u.indexOf("tablet pc") == -1)
      || u.indexOf("ipad") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") == -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("tablet") != -1)
      || u.indexOf("kindle") != -1
      || u.indexOf("silk") != -1
      || u.indexOf("playbook") != -1,
    isMobile:(u.indexOf("windows") != -1 && u.indexOf("phone") != -1)
      || u.indexOf("iphone") != -1
      || u.indexOf("ipod") != -1
      || (u.indexOf("android") != -1 && u.indexOf("mobile") != -1)
      || (u.indexOf("firefox") != -1 && u.indexOf("mobile") != -1)
      || u.indexOf("blackberry") != -1
  }
})(window.navigator.userAgent.toLowerCase());

//IE・Edge判定
var isEdge = false;
var userAgent = window.navigator.userAgent.toLowerCase();
if( userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/) ) {
  var isIE = true;
  var ieVersion = userAgent.match(/((msie|MSIE)\s|rv:)([\d\.]+)/)[3];
  ieVersion = parseInt(ieVersion);
} else {
  var isIE = false;
  if(userAgent.indexOf("edge" )!= -1){
    isEdge = true;
  }
}


(function($){
  $(function(){
    //スマホメニュー
    spmenu();

    //iOS リンクのダブルタップバグ
    if(/iPhone|iPad|iPod/.test(ua)) {
      $("body").addClass("_ios");
    }

    //PCのとき 電話番号 無効
    if(!_ua.isMobile){
      $(".-telink").on('click', function(){
        return false;
      });
    }

    //スムーズスクロール
    if(location.href.indexOf("file")==0){
      var url = "file://" + location.hostname + location.pathname + location.search;
    }else if(location.href.indexOf("https")==0){
      var url = "https://" + location.hostname + location.pathname + location.search;
    }else{
      var url = "http://" + location.hostname + location.pathname + location.search;
    }
    $('a[href*="#"],area[href*="#"]').on('click', function() {
      var id = this.href.substring(this.href.indexOf('#'),this.href.length);
      var hrefUrl = this.href.split(id);
      if(String(hrefUrl[0]) == String(url)) {
        var hash = this.hash;
        if(!hash || hash == "#") {
          return false;
        }else if(id == '#inbox') {
          $('html, body').animate({scrollTop: 0}, 1000, "easeOutQuart");
          return false;
        }else if(id != "#"){
          $('html, body').animate({scrollTop: $(hash).offset().top - $("#shopify-section-header").height()}, 1000, "easeOutQuart");
          return false;
        }
      }
    });

    // resize
    //$(window).on('resize', function () {
    //  // resize check exec
    //  if (resizeTimer !== false) {
    //    clearTimeout(resizeTimer);
    //  }
    //  resizeTimer = setTimeout(function() {
    //    checkWindowSize();
    //  }, 200);
    //});
  });


  // on Load event
  $(window).on('load', function(){
    //checkWindowSize();
  });


  //スマホメニュー
  var menuState = false;
  var menuPos;
  function spmenu() {
    var menu = $('#sp-nav'),
        menuBtn = $('#js-menuButton');

    // open
    menuBtn.on('click', function(){
      menu.stop().fadeToggle(300);
      $(this).toggleClass("-open");
      if(menuState == false) { // スクロールを無効
        menuPos = $(window).scrollTop();
        $('body').addClass('-fixed').css({'top': -menuPos});
        menuState = true;
      } else {
        $('body').removeClass('-fixed').css({'top': 0});
        window.scrollTo(0, menuPos );
        menuState = false;
      }
    });

    $(window).on('resize', function () {
      var windowW = $(window).width();
      if(menu.length && windowW>960 && menuState!=false){
        menu.hide();
        menuBtn.removeClass("-open");
        $('body').removeClass('-fixed').css({'top': 0});
        window.scrollTo(0,menuPos);
        menuState = false;
      }
    });
  }

  // resize check exec
  //var resizeTimer = false;
  //function checkWindowSize(){
  //  var windowW = $(window).width();
  //  if(windowW > 960 ){
  //    $("").each(function() {
  //      $(this).find("li").tile(3);
  //    });
  //  } else {
  //    $("").find("li").height("auto");
  //  }
  //}
  $(function(){
    var swiper = new Swiper(".mv-slide-container",{
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      slidesPerView: '1',
      speed: 1000,
    });
  });

  $(function(){
    $('.contact-addressBtn').on('click',function(){
      AjaxZip3.zip2addr('contact[郵便番号]','','contact[住所]','contact[住所]');

      //成功時に実行する処理
      AjaxZip3.onSuccess = function() {
        $('.adr').focus();
      };

      //失敗時に実行する処理
      AjaxZip3.onFailure = function() {
        alert('郵便番号に該当する住所が見つかりません');
      }; 

      return false;
     
    });
  });

  $(function(){
    if($(window).width() > 900){
    $('.tabtable-area').each(function(i){
      $(this).addClass('table-tab' + (i+1));
      if($('.tabtitle-block .lead').innerHeight() > 22 ){
        $('.tabtitle-block .lead').addClass('sml');
      }else{}
    });
    $('.tabtable-area').wrapAll('<div class="l-section -fill -pt0 tabarea">');
    $('.l-section.-fill.tabarea').wrapInner('<div class="page-content">');
    
    var $tab_btn = $('.tabarea .page-content .tabBtn');
    var $tab_panel = $('.tabarea .page-content .js-panel');
    // タブメニュー
    $tab_panel.hide();
    $tab_panel.eq(0).show();
    $tab_btn .eq(0).addClass('-current');

    $tab_btn .on('click', function () {
      var index = $tab_btn .index(this);
      $tab_btn .removeClass('-current');
      $(this).addClass('-current');
      $tab_panel.hide();
      $tab_panel.eq(index).show();
    });
    }else{}
  });

  //取引実績 タグ一覧並び替え
  $(function(){
    let pref_order = ['香川県','徳島県','愛媛県','高知県','岡山県','広島県','鳥取県','島根県','山口県','北海道','青森県','岩手県','宮城県','秋田県','山形県','福島県','茨城県','栃木県','群馬県','埼玉県','千葉県','東京都','神奈川県','新潟県','富山県','石川県','福井県','山梨県','長野県','岐阜県','静岡県','愛知県','三重県','滋賀県','京都府','大阪府','兵庫県','奈良県','和歌山県', '福岡県','佐賀県','長崎県','熊本県','大分県','宮崎県','鹿児島県','沖縄県']; //順番
    let pref_list = []; //タグ名を格納
    
    //配列にタグ名を格納
    $('.js-pref-list li').each(function(){
      pref_list.push($(this).data('pref'));
    })

    //タグ一覧の順番を並び替える
    pref_order.map(function(el){
      if($.inArray(el,pref_list) !== -1) {
        $('li[data-pref='+ el +']').appendTo('.js-pref-list');
      }
    })

    //リストを表示
    $('.js-side-contents').css('visibility','visible');
    
  })

  //よくあるご質問
  $(function(){
    $('.cp-faq-q').on('click',function(){
      $(this).toggleClass('-open').next('.cp-faq-a').stop().slideToggle();
    })
  })

})(jQuery);

